const drillDownXTitle = 'Risk Factors';

export default drillDownXTitle;
